import { render } from "./WebPushPage.vue?vue&type=template&id=60691467"
import script from "./WebPushPage.vue?vue&type=script&lang=js"
export * from "./WebPushPage.vue?vue&type=script&lang=js"

import "./WebPushPage.vue?vue&type=style&index=0&id=60691467&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__